<template>
  <div class="dh-psy-journal-series article-feature">
    <div v-if="date" class="dh-psy-journal-series__date-wrapper" :aria-label="dateLabel">
      <div class="dh-psy-journal-series__date" aria-hidden>
        <span class="dh-psy-journal-series__day dh-psy-journal-series__day--short">{{ date.value.day.slice(0,2) }}</span>
        <span class="dh-psy-journal-series__day dh-psy-journal-series__day--long">{{ date.value.day }}</span>
        <span class="dh-psy-journal-series__month dh-psy-journal-series__month--long">{{ date.value.month }}</span>
        <span class="dh-psy-journal-series__month dh-psy-journal-series__month--short">{{ date.value.month.slice(0, 3) }}</span>
      </div>
    </div>
    <div v-for="(item, idx) in items" :key="idx" class="dh-psy-journal-series__content">
      <component :is="item.componentType" :content='item.content' :title='item.title' :author="item.author" :subtitle="item.subtitle" :inverse="item.inverse === 'true'" />
    </div>
  </div>
</template>

<script>
import Journal from '../Journal/index.vue'
import Diary from '../Diary/index.vue'

export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    date() {
      return this.item.value.find(item => {
        return item.type === 'date'
      })
    },
    dateLabel() {
      return `${this.date.value.day} ${this.date.value.month}`
    },
    items() {
      return this.item.value
        .filter(item => {
          return item.type !== 'date'
        })
        .map(item => ({
          ...item.value,
          componentType: item.type === 'journal' ? Journal : Diary
        }))
    }
  }
}
</script>

<style lang="postcss" scoped>
  .dh-psy-journal-series > * {
    float: none;
  }
  .dh-psy-journal-series {
    position: relative;
    height: 100%;
    padding: 0;
    margin: 60px auto 10px;

    @media (min-width: 800px) {
      margin: 50px auto 100px;
    }
  }
  .dh-psy-journal-series__date-wrapper {
    font-family: 'NRK Etica Slab';
    text-align: center;
    margin: 0 auto 50px;
  }
  .dh-psy-journal-series__date {
    display: inline-block;
    line-height: 1;
    box-shadow: 0px 4px white inset, 0px -4px white inset, 2px 39px #8debd6 inset;
  }

  .dh-psy-journal-series__day {
    display: inline-block;
    position: relative;
  }

  .dh-psy-journal-series__day--short,
  .dh-psy-journal-series__month--short {
    display: none;
  }

  .dh-psy-journal-series__content {
    margin: 0 0 100px;

    &:last-of-type {
      margin-bottom: 0;

      @media (min-width: 900px) {
        margin-bottom: 50px;
      }
    }
  }

  @media (min-width: 900px) {
    .dh-psy-journal-series__content:first-of-type {
    }
    .dh-psy-journal-series__day {
      margin: 0 0 3px;
      padding-bottom: 5px;
      font-size: 2.2em;
      line-height: 1;
      box-shadow: 2px 0px 0 0px white inset, -2px 0px 0 0px white inset, 0px 14px white inset,
        0px -16px white inset, 2px 39px #8debd6 inset;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 5px;
        right: 5px;
        border-bottom: 1px solid #979797;
      }
    }

    .dh-psy-journal-series__month {
      font-size: 1.1em;
    }

    .dh-psy-journal-series__day--short,
    .dh-psy-journal-series__month--short {
      display: block;
    }

    .dh-psy-journal-series__day--long,
    .dh-psy-journal-series__month--long {
      display: none;
    }

    .dh-psy-journal-series__date-wrapper {
      margin: auto auto -100px -68px;
      position: sticky;
      top: 50px;
      height: 100px;
      width: 50px;
      box-shadow: none;
    }
    .dh-psy-journal-series__date {
      box-shadow: none;
    }
  }
</style>
